import Recorder from "js-audio-recorder";
import { alertController } from "@ionic/vue";
import requestApi from "@/js/http";
import { uploadFileToOss } from "@/views/AIGenerate/essayList/uploadFileToOss";
export default class WinRecord {
  public record: any;
  public time: any;
  public playTime: any;
  public timer: any;
  public src: any;
  public url: string;
  constructor(url: string) {
    this.url = url;
  }

  handleStart = () => {
    this.record = new Recorder();
    const record: any = Recorder;
    record?.getPermission().then(
      () => {
        console.log("开始录音");
        this.record.start(); // 开始录音
      },
      async () => {
        console.log("失败");
        const alert = await alertController.create({
          subHeader: "请允许使用麦克风权限",
          buttons: [],
        });
        await alert.present();
      }
    );
  };

  handlePause = async (callback: any, conversationId: any) => {
    console.log("暂停录音");
    this.record.pause(); // 暂停录音
    await this.uploadRecord(callback, conversationId);
  };
  handleResume = () => {
    console.log("恢复录音");
    this.record.resume(); // 恢复录音
  };
  handleStop = () => {
    console.log("停止录音");
    this.record.stop(); // 停止录音
  };

  handlePlay = () => {
    console.log("播放录音");
    this.record.play(); // 播放录音

    // 播放时长
    this.timer = setInterval(() => {
      try {
        this.playTime = this.record.getPlayTime();
      } catch (error) {
        this.timer = null;
      }
    }, 100);
  };
  handlePausePlay = () => {
    console.log("暂停播放");
    this.record.pausePlay(); // 暂停播放

    // 播放时长
    this.playTime = this.record.getPlayTime();
    this.time = null;
  };
  handleResumePlay = () => {
    console.log("恢复播放");
    this.record.resumePlay(); // 恢复播放

    // 播放时长
    this.timer = setInterval(() => {
      try {
        this.playTime = this.record.getPlayTime();
      } catch (error) {
        this.timer = null;
      }
    }, 100);
  };
  handleStopPlay = () => {
    console.log("停止播放");
    this.record.stopPlay(); // 停止播放

    // 播放时长
    this.playTime = this.record.getPlayTime();
    this.timer = null;
  };
  handleDestroy = () => {
    return new Promise((resolve) => {
      console.log("销毁实例");
      if (this.record) {
        this.record.destroy().then(() => {
          this.record = null;
          this.timer = null;
          resolve("成功");
        }); // 毁实例
      }
    });
  };
  uploadRecord = async (callback: any, conversationId: string) => {
    if (this.record == null || this.record.duration === 0) {
      const alert = await alertController.create({
        subHeader: "请允许使用麦克风权限",
        buttons: [],
      });
      await alert.present();
      return false;
    }
    this.record.pause(); // 暂停录音
    this.timer = null;
    console.log("上传录音"); // 上传录音

    const formData = new FormData();
    const blob = this.record.getWAVBlob(); // 获取wav格式音频数据
    // 此处获取到blob对象后需要设置fileName满足当前项目上传需求，其它项目可直接传把blob作为file塞入formData
    const newbolb = new Blob([blob], { type: "audio/wav" });
    const fileOfBlob = new File([newbolb], new Date().getTime() + ".wav");
    formData.append("file", fileOfBlob);
    formData.append("conversationId", conversationId);
    this.src = window.URL.createObjectURL(fileOfBlob);

    requestApi
      .post(this.url + "api/chatForSpeech", formData)
      .then(async (res) => {
        if (res.data.code === 500) {
          const alert = await alertController.create({
            subHeader: res.data.msg,
            buttons: [],
          });
          await alert.present();
        } else {
          callback(res);
        }
      })
      .catch((error: any) => {
        console.log(error);
      });
  };
  uploadRecord2 = (id: any) => {
    return new Promise((resolve) => {
      this.record.pause(); // 暂停录音
      this.timer = null;
      console.log("上传录音"); // 上传录音
      const formData = new FormData();
      const blob = this.record.getWAVBlob(); // 获取wav格式音频数据
      // 此处获取到blob对象后需要设置fileName满足当前项目上传需求，其它项目可直接传把blob作为file塞入formData
      const newbolb = new Blob([blob], { type: "audio/wav" });
      const fileOfBlob = new File([newbolb], id + ".wav");
      formData.append("file", fileOfBlob);
      formData.append("key", "teacher/introduction/" + id + ".wav");
      uploadFileToOss(fileOfBlob).then((res) => {
        resolve(res);
      });
      // this.src = window.URL.createObjectURL(fileOfBlob)
    });
  };
}
